import React from 'react';

import LargeCautionIcon from '../Icons/LargeCautionIcon';
import ContainedPlainSuccessModal from '../Modal/ContainedPlainSuccessModal';

interface KycRequiredProps {
  successActionFn: (...args: any[]) => void;
  message: string;
}

const KycRequired: React.FC<KycRequiredProps> = ({
  successActionFn,
  message,
}) => {
  return (
    <ContainedPlainSuccessModal
      successActionFn={successActionFn}
      description={message}
      btnLabel='Complete KYC'
      title='KYC Required'
      hasCancelBtn={true}
      customIcon={<LargeCautionIcon />}
      className='transparent'
    />
  );
};

export default KycRequired;
